import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

const getIcareState = (state: RootState) => state.icare;

export const selectMessages = createSelector(
  [getIcareState],
  (icare) => icare.messages
);

export const selectSearchMessages = createSelector(
  [getIcareState],
  (icare) => icare.searchMessages
);
